import React from 'react';
import { Button } from 'semantic-ui-react';

export const Submit = (props) => {
  return (
    <Button type='submit' primary size='big' {...props.config}>{props.label}</Button>
  );
};
